import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';

const YellowButton: React.FC<ButtonProps> = (props) => (
    <Button
        variant="contained"
        disableElevation
        sx={{
            backgroundColor: '#F2D964',
            // Double-ampersand keeps the dark label winning over the global
            // `a:link` colour when this button renders as an <a href> (e.g. the
            // "Complete profile" CTA) — otherwise it inherited the blue link colour.
            '&&': { color: '#0B3139' },
            fontWeight: 600,
            borderRadius: '999px',
            paddingX: 3,
            paddingY: 1,
            textTransform: 'none',
            whiteSpace: 'nowrap',
            '&:hover': { backgroundColor: '#EBCF4E' },
        }}
        {...props}
    />
);

export default YellowButton;
